module.exports = __webpack_public_path__ + "static/media/Prosper-Card-Front.0aa29408.png";